/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { IImageTests } from 'app/shared/model/image-tests.model';
import { IDiagLabPanel } from 'app/shared/model/diag-lab-panel.model';
import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { AssociationType } from 'app/shared/model/enumerations/association-type.model';

export interface IRadiologyReportTemplate {
  id?: string;
  charset?: string | null;
  path?: string | null;
  reportBody?: string | null;
  dcTermsTitle?: string | null;
  dcTermsDescription?: string | null;
  dcTermsIdentifier?: string | null;
  dcTermsType?: string | null;
  dcTermsLanguage?: string | null;
  dcTermsPublisher?: string | null;
  dcTermsRights?: string | null;
  dcTermsLicense?: string | null;
  dcTermsDate?: string | null;
  dcTermsCreator?: string | null;
  voided?: boolean | null;
  dateVoided?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  lastUpdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  associationType?: keyof typeof AssociationType | null;
  doctor?: IDoctor | null;
  lab?: IDiagLab | null;
  test?: IImageTests | null;
  panel?: IDiagLabPanel | null;
  testItem?: ILabTestItem | null;
}

export const defaultValue: Readonly<IRadiologyReportTemplate> = {
  voided: false,
  active: false,
};
